<template>
  <main>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="mb-0">Lihat Data Jemaat</p>
                <argon-button color="danger" size="sm" class="ms-auto" @click="back()"
                  >Kembali</argon-button
                >
              </div>
            </div>
            <div class="card-body">
              <tabs>
                <tab name="Informasi Jemaat">
                  <div class="row">
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Nomor KK</label
                      >
                      <argon-input type="text" v-model:value="datas.ID_KELUARGA" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Nama Keluarga</label
                      >
                      <argon-input type="text" v-model:value="datas.keluarga.NAMA_KELUARGA" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Wilayah</label
                      >
                      <VueMultiselect
                        v-model="datas.WILAYAH"
                        :options="data_wilayah"
                        :multiple="false"
                        :close-on-select="true"
                        placeholder="-"
                        label="wilayah"
                        track-by="wilayah"
                        :disabled="true"
                      />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Sektor</label
                      >
                      <VueMultiselect
                        v-model="datas.SEKTOR"
                        :options="data_sektor"
                        :multiple="false"
                        :close-on-select="true"
                        placeholder="-"
                        label="nama"
                        track-by="nama"
                        :disabled="true"
                      />
                    </div>
                    <div class="col-md-12">
                      <label for="example-text-input" class="form-control-label"
                        >Nama</label
                      >
                      <argon-input type="text" v-model:value="datas.NAMA" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Jenis Kelamin</label
                      >
                      <VueMultiselect
                        v-model="datas.JK"
                        :options="[{'id': 'L', 'nama':'Laki-Laki'},{'id': 'P', 'nama':'Perempuan'}]"
                        :multiple="false"
                        :close-on-select="true"
                        placeholder="-"
                        label="nama"
                        track-by="nama"
                        :disabled="true"
                      />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Tanggal Lahir</label
                      >
                      <argon-input type="date" v-model:value="datas.TGL_LAHIR" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Tempat Lahir</label
                      >
                      <argon-input type="text" v-model:value="datas.TEMPAT_KELAHIRAN" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Status</label
                      >
                      <VueMultiselect
                        v-model="datas.STATUS"
                        :options="data_status"
                        :multiple="false"
                        :close-on-select="true"
                        placeholder="-"
                        label="nama"
                        track-by="nama"
                        :disabled="true"
                      />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Status Aktif</label
                      >
                      <VueMultiselect
                        v-model="datas.STATUS_AKTIF"
                        :options="[{'id': '1', 'nama':'Aktif'},{'id': '0', 'nama':'Tidak Aktif'}]"
                        :multiple="false"
                        :close-on-select="true"
                        placeholder="-"
                        label="nama"
                        track-by="nama"
                        :disabled="true"
                      />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Status Perkawinan</label
                      >
                      <VueMultiselect
                        v-model="datas.STATUS_PERKAWINAN"
                        :options="data_perkawinan"
                        :multiple="false"
                        :close-on-select="true"
                        placeholder="-"
                        label="nama"
                        track-by="nama"
                        :disabled="true"
                      />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Nama Ayah</label
                      >
                      <argon-input type="text" v-model:value="datas.AYAH" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Nama Ibu</label
                      >
                      <argon-input type="text" v-model:value="datas.IBU" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Kewarganegaraan</label
                      >
                      <argon-input type="text" v-model:value="datas.KEWARGANEGARAAN" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Golongan Darah</label
                      >
                      <VueMultiselect
                        v-model="datas.GOL_DARAH"
                        :options="data_goldar"
                        :multiple="false"
                        :close-on-select="true"
                        placeholder="-"
                        label="nama"
                        track-by="nama"
                        :disabled="true"
                      />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Tanggal Baptis</label
                      >
                      <argon-input type="date" v-model:value="datas.TGL_BAPTIS" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Tempat Baptis</label
                      >
                      <argon-input type="text" v-model:value="datas.TEMPAT_BAPTIS" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Tanggal Sidi</label
                      >
                      <argon-input type="date" v-model:value="datas.TGL_SIDI" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Tempat Sidi</label
                      >
                      <argon-input type="text" v-model:value="datas.TEMPAT_SIDI" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Dibaptis Oleh</label
                      >
                      <argon-input type="text" v-model:value="datas.DIBAPTIS_OLEH" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Disidi Oleh</label
                      >
                      <argon-input type="text" v-model:value="datas.DISIDI_OLEH" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Pindahan (Attestasi) Ke Gereja</label
                      >
                      <argon-input type="text" v-model:value="datas.PINDAHAN_KE" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Pindahan (Attestasi) Masuk</label
                      >
                      <argon-input type="text" v-model:value="datas.PINDAHAN" disabled="true" />
                    </div>
                    <div class="col-md-6 ">
                      <label for="example-text-input" class="form-control-label"
                        >Tanggal Pindah</label
                      >
                      <argon-input type="date" v-model:value="datas.TANGGAL_PINDAH" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Pendidikan Terakhir</label
                      >
                      <VueMultiselect
                        v-model="datas.PENDIDIKAN"
                        :options="data_pendidikan"
                        :multiple="false"
                        :close-on-select="true"
                        placeholder="-"
                        label="nama"
                        track-by="nama"
                        :disabled="true"
                      />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Jurusan</label
                      >
                      <argon-input type="text" v-model:value="datas.JURUSAN" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Disabilitas</label
                      >
                      <VueMultiselect
                        v-model="datas.DISABILITAS"
                        :options="[{'id': '0', 'nama':'Tidak'},{'id': '1', 'nama':'Ya'}]"
                        :multiple="false"
                        :close-on-select="true"
                        placeholder="-"
                        label="nama"
                        track-by="nama"
                        :disabled="true"
                      />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Pindahan Agama</label
                      >
                      <VueMultiselect
                        v-model="PINDAHANS"
                        :options="[{'id': '0', 'nama':'Tidak'},{'id': '1', 'nama':'Dari Kristen'},{'id': '2', 'nama':'Ke Kristen'}]"
                        :multiple="false"
                        :close-on-select="true"
                        placeholder="-"
                        label="nama"
                        track-by="nama"
                        :disabled="true"
                      />
                    </div>
                    <div class="col-md-6 ">
                      <label for="example-text-input" class="form-control-label"
                        >Tempat Semayam</label
                      >
                      <argon-input type="text" v-model:value="datas.TEMPAT_SEMAYAM" disabled="true" />
                    </div>
                    <div class="col-md-6 ">
                      <label for="example-text-input" class="form-control-label"
                        >Tanggal Meninggal</label
                      >
                      <argon-input type="date" v-model:value="datas.TANGGAL_MENINGGAL" disabled="true" />
                    </div>
                    <div class="col-md-6 ">
                      <label for="example-text-input" class="form-control-label"
                        >Tanggal Pindahan Ke Kristen (Jika Ada)</label
                      >
                      <argon-input type="date" v-model:value="datas.TGL_AGAMA_LAIN" disabled="true" />
                    </div>
                    <div class="col-md-6 ">
                      <label for="example-text-input" class="form-control-label"
                        >Tanggal Pindahan Dari Kristen (Jika Ada)</label
                      >
                      <argon-input type="date" v-model:value="datas.TGL_DARI_KRISTEN" disabled="true" />
                    </div>
                  </div>
                </tab>
                <tab name="Kontak Jemaat">
                  <div class="row">
                    <div class="col-md-12">
                      <label for="example-text-input" class="form-control-label"
                        >Alamat</label
                      >
                      <argon-input type="text" v-model:value="datas.ALAMAT" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Kota</label
                      >
                      <argon-input type="text" v-model:value="datas.KOTA" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Provinsi</label
                      >
                      <argon-input type="text" v-model:value="datas.PROPINSI" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Negara</label
                      >
                      <argon-input type="text" v-model:value="datas.NEGARA" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Kodepos</label
                      >
                      <argon-input type="text" v-model:value="datas.KODEPOS" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Telp / HP</label
                      >
                      <argon-input type="text" v-model:value="datas.HP" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >e-mail</label
                      >
                      <argon-input type="text" v-model:value="datas.EMAIL" disabled="true" />
                    </div>
                  </div>
                </tab>
                <tab name="Data Pekerjaan, dll">
                  <div class="row">
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Pekerjaan</label
                      >
                      <VueMultiselect
                        v-model="datas.PEKERJAAN"
                        :options="data_pekerjaan"
                        :multiple="false"
                        :close-on-select="true"
                        placeholder="-"
                        label="nama"
                        track-by="nama"
                        :disabled="true"
                      />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Tempat Kerja / USAHA</label
                      >
                      <argon-input type="text" v-model:value="datas.TEMPAT_KERJA" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Alamat Kerja / Usaha</label
                      >
                      <argon-input type="text" v-model:value="datas.ALAMAT_KERJA" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Bidang Usaha</label
                      >
                      <argon-input type="text" v-model:value="datas.BIDANG_USAHA" disabled="true" />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Jabatan / Pangkat</label
                      >
                      <VueMultiselect
                        v-model="datas.JABATAN"
                        :options="data_jabatan"
                        :multiple="false"
                        :close-on-select="true"
                        placeholder="-"
                        label="nama"
                        track-by="nama"
                        :disabled="true"
                      />
                    </div>
                    <div class="col-md-6">
                      <label for="example-text-input" class="form-control-label"
                        >Profesi</label
                      >
                      <VueMultiselect
                        v-model="datas.PROFESI"
                        :options="data_profesi"
                        :multiple="false"
                        :close-on-select="true"
                        placeholder="-"
                        label="nama"
                        track-by="nama"
                        :disabled="true"
                      />
                    </div>
                    <div class="col-md-12">
                      <label for="example-text-input" class="form-control-label"
                        >Hobby</label
                      >
                      <VueMultiselect
                        v-model="HOBBY2"
                        :options="data_hobby"
                        :multiple="true"
                        :close-on-select="true"
                        placeholder="-"
                        label="nama"
                        track-by="nama"
                        :disabled="true"
                      />
                    </div>
                    <div class="col-md-12">
                      <label for="example-text-input" class="form-control-label"
                        >Minat</label
                      >
                      <VueMultiselect
                        v-model="MINAT2"
                        :options="data_minat"
                        :multiple="true"
                        :close-on-select="true"
                        placeholder="-"
                        label="nama"
                        track-by="nama"
                        :disabled="true"
                      />
                    </div>
                    <div class="col-md-12">
                      <label for="example-text-input" class="form-control-label"
                        >Minat Bidang Pelayanan</label
                      >
                      <VueMultiselect
                        v-model="MINAT_PELAYANAN2"
                        :options="data_pelayanan"
                        :multiple="true"
                        :close-on-select="true"
                        placeholder="-"
                        label="nama"
                        track-by="nama"
                        :disabled="true"
                      />
                    </div>
                  </div>
                </tab>
            </tabs>
            </div>
          </div>
        </div>
      </div>
    <auth-check></auth-check>
    </div>
  </main>
</template>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<script>
/* eslint-disable */
import setNavPills from "@/assets/js/nav-pills.js";
import setTooltip from "@/assets/js/tooltip.js";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import VueMultiselect from 'vue-multiselect'
import AuthCheck from '@/components/authCheck.vue'

const body = document.getElementsByTagName("body")[0];

export default {
  name: "view-data-jemaat",
  data() {
    return {
      showMenu: false,
      datas: {
        id: 0,
        ALAMAT: "",
        ALAMAT_KERJA: "",
        AYAH: "",
        BIDANG_USAHA: "",
        DIBAPTIS_OLEH: "",
        DISIDI_OLEH: "",
        EMAIL: "",
        GOL_DARAH: "",
        HOBBY: "",
        HP: "",
        IBU: "",
        ID_JEMAAT: 0,
        ID_KELUARGA: 0,
        JABATAN: "",
        JK: "",
        JURUSAN: "",
        KEWARGANEGARAAN: "",
        KODEPOS: "",
        KOTA: "",
        MINAT: "",
        MINAT_PELAYANAN: "",
        NAMA: "",
        NEGARA: "",
        PEKERJAAN: "",
        PENDIDIKAN: "",
        PERAN: "",
        PINDAHAN: "",
        PINDAHAN_KE: "",
        PINDAHAN_AGAMA_LAIN: "",
        PINDAHAN_DARI_KRISTEN: "",
        PROFESI: "",
        PROPINSI: "",
        SEKTOR: 0,
        STATUS: "1",
        STATUS_AKTIF: "1",
        STATUS_PERKAWINAN: "",
        TANGGAL_MENINGGAL: null,
        TANGGAL_PINDAH: null,
        TEMPAT_BAPTIS: "",
        TEMPAT_KELAHIRAN: "",
        TEMPAT_KERJA: "",
        TEMPAT_SEMAYAM: null,
        TEMPAT_SIDI: "",
        TGL_AGAMA_LAIN: "",
        TGL_BAPTIS: "",
        TGL_DARI_KRISTEN: "",
        TGL_LAHIR: "",
        TGL_SIDI: "",
        WILAYAH: 0,
        DISABILITAS: "",
        keluarga: {
          ID_KELUARGA: 0,
          NAMA_KELUARGA: "",
        },
      },
      MINAT2: "",
      HOBBY2: "",
      MINAT_PELAYANAN2: "",
      PINDAHANS: "",
      data_wilayah: [],
      data_sektor: [],
      data_goldar: [],
      data_hobby: [],
      data_jabatan: [],
      data_minat: [],
      data_pekerjaan: [],
      data_pelayanan: [],
      data_pendidikan: [],
      data_perkawinan: [],
      data_profesi: [],
      data_status: [],
    };
  },
  components: {
    ArgonInput,
    VueMultiselect,
    ArgonButton,
    AuthCheck,
  },
  methods: {
    back(){
      this.$router.push("/data-jemaat");
    },
  },
  mounted() {
    this.$store.state.isAbsolute = true;
    this.axios.get(process.env.VUE_APP_API_URL + "data", {headers: {
      "Authorization": "Bearer " + localStorage.getItem("token")
    }}).then((resp) => {
      this.data_wilayah = JSON.parse(JSON.stringify(resp.data)).wilayah
      this.data_sektor = JSON.parse(JSON.stringify(resp.data)).sektor
      this.data_goldar = JSON.parse(JSON.stringify(resp.data)).goldar
      this.data_hobby = JSON.parse(JSON.stringify(resp.data)).hobby
      this.data_jabatan = JSON.parse(JSON.stringify(resp.data)).jabatan
      this.data_pekerjaan = JSON.parse(JSON.stringify(resp.data)).pekerjaan
      this.data_pelayanan = JSON.parse(JSON.stringify(resp.data)).pelayanan
      this.data_pendidikan = JSON.parse(JSON.stringify(resp.data)).pendidikan
      this.data_perkawinan = JSON.parse(JSON.stringify(resp.data)).perkawinan
      this.data_profesi = JSON.parse(JSON.stringify(resp.data)).profesi
      this.data_status = JSON.parse(JSON.stringify(resp.data)).status
      this.data_minat = JSON.parse(JSON.stringify(resp.data)).minat

      if(this.$route.params.id != null){
        this.axios.get(process.env.VUE_APP_API_URL + "jemaat/"+this.$route.params.id, {headers: {
          "Authorization": "Bearer " + localStorage.getItem("token")
        }}).then((resp) => {
          this.datas = JSON.parse(JSON.stringify(resp.data.data))
          if(this.datas.PINDAHAN_AGAMA_LAIN == "1" && this.datas.PINDAHAN_DARI_KRISTEN == "1" && Date(this.datas.TGL_AGAMA_LAIN) < Date(this.datas.TGL_DARI_KRISTEN)){
            this.PINDAHANS = {'id': '1', 'nama':'Dari Kristen'}
          } else if (this.datas.PINDAHAN_AGAMA_LAIN == "1" && this.datas.PINDAHAN_DARI_KRISTEN == "1" && Date(this.datas.TGL_AGAMA_LAIN) > Date(this.datas.TGL_DARI_KRISTEN)){
            this.PINDAHANS = {'id': '2', 'nama':'Ke Kristen'}
          } else if (this.datas.PINDAHAN_AGAMA_LAIN == "1" && this.datas.PINDAHAN_DARI_KRISTEN == "0"){
            this.PINDAHANS = {'id': '2', 'nama':'Ke Kristen'}
          } else if (this.datas.PINDAHAN_AGAMA_LAIN == "0" && this.datas.PINDAHAN_DARI_KRISTEN == "1"){
            this.PINDAHANS = {'id': '1', 'nama':'Dari Kristen'}
          } else {
            this.PINDAHANS = {'id': '0', 'nama':'Tidak'}
          }

          if(this.datas.STATUS_AKTIF == "1"){
            this.datas.STATUS_AKTIF = {'id': '1', 'nama':'Aktif'}
          } else {
            this.datas.STATUS_AKTIF = {'id': '0', 'nama':'Tidak Aktif'}
          }

          if (this.datas.MINAT != null){
            this.MINAT2 = this.data_minat.filter(x => this.datas.MINAT.split(", ").includes(x.nama));
          }
          if (this.datas.MINAT_PELAYANAN != null){
            this.MINAT_PELAYANAN2 = this.data_pelayanan.filter(x => this.datas.MINAT_PELAYANAN.split(", ").includes(x.nama));
          }
          if (this.datas.HOBBY != null){
            this.HOBBY2 = this.data_hobby.filter(x => this.datas.HOBBY.split(", ").includes(x.nama));
          }
          if (this.datas.keluarga == null){
            this.datas.keluarga = {'ID_KELUARGA': '-', 'NAMA_KELUARGA': '-'}
          }
        })
      }
    });
    setNavPills();
    setTooltip();
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = false;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>
